module.exports = __webpack_public_path__ + "assets/civic.11f66b31.svg";